import { Box, Tooltip } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { getAttachmentThumbSx, getAttachmentThumbImgStyle } from './attachmentStripSx';
// ADDED — Jerny tooltip styling, consistent with rest of app
import { tooltipSx } from '../../../components/shared/jernyTooltipStyling';

const _imageTypes = ['image/webp', 'image/jpeg', 'image/png', 'image/gif'];

/**
 * AttachmentThumbnail — renders one document as thumbnail or file icon.
 * Image mimeTypes → img with rotation CSS. Others → file icon, click = download.
 * uploadFailed === true → blinking red/dark border, click disabled.
 * @param {object} props
 * @param {object} props.document - document entity { rk, url, fileName, mimeType, description, rotation, uploadFailed }
 * @param {number} props.index - absolute index in documents array, passed to lightbox
 * @param {Function} props.onLightBox - fn(index) called on image click
 */
export default function AttachmentThumbnail({ document, index, onLightBox }) {
    const isImage = _imageTypes.includes(document.mimeType);

    // Failed uploads are shown grayed out — no interaction until retry succeeds
    const isFailed = document.uploadFailed === true;

    /**
     * Opens lightbox for images, download tab for other file types.
     * Blocked when upload failed — no real storage URL available yet.
     */
    const handleClick = () => {
        if (isFailed) return;
        if (isImage) {
            onLightBox?.(index);
        } else {
            window.open(document.url, '_blank');
        }
    };

    return (
        <Tooltip
            title={isFailed ? `Upload mislukt — ${document.fileName}` : (document.description || document.fileName)}
            // Bottom placement — tooltip never covers the strip buttons above
            placement="bottom"
            componentsProps={tooltipSx}
        >
            <Box
                id={`attachment-thumb-${document.rk}`}
                onClick={handleClick}
                sx={{
                    ...getAttachmentThumbSx(),
                    ...(isFailed && {
                        opacity: 0.45,
                        cursor: 'not-allowed',
                        // Blink border red → dark → red — unmissable failed state
                        animation: 'thumb-fail-blink 0.8s step-start infinite',
                        '@keyframes thumb-fail-blink': {
                            '0%':   { border: '2px solid #ff6b6b' },
                            '50%':  { border: '2px solid #1a0a0a' },
                            '100%': { border: '2px solid #ff6b6b' },
                        },
                    }),
                }}
            >
                {isImage ? (
                    <img
                        src={document.url}
                        alt={document.fileName}
                        style={getAttachmentThumbImgStyle(document.rotation)}
                    />
                ) : (
                    <InsertDriveFileIcon sx={{ color: 'var(--j-muted)', fontSize: 28 }} />
                )}
            </Box>
        </Tooltip>
    );
}
